export const FETCH_VACANCY = "FETCH_VACANCY";

export const FETCH_VACANCY_ERROR = "FETCH_VACANCY_ERROR";

export const RESET_VACANCY_STATUS = "RESET_VACANCY_STATUS";

export const FETCH_VACANCY_PENDING = "FETCH_VACANCY_PENDING";
